(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  document.querySelectorAll('[data-copy-link]').forEach((button) => {
    if (button.dataset.copyReady === 'true') {
      return;
    }

    button.dataset.copyReady = 'true';

    button.addEventListener('click', async () => {
      const url = button.getAttribute('data-copy-link');

      if (!url) {
        return;
      }

      try {
        await navigator.clipboard.writeText(url);
        const previousLabel = button.getAttribute('title');

        button.setAttribute('title', 'Link copiado');
        button.setAttribute('aria-label', 'Link copiado');
        button.classList.add('is-copied');

        window.setTimeout(() => {
          if (previousLabel) {
            button.setAttribute('title', previousLabel);
            button.setAttribute('aria-label', previousLabel);
          }
          button.classList.remove('is-copied');
        }, 1800);
      } catch (error) {
        window.prompt('Copie o link do artigo:', url);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  // const hideAmoButtonHolders = () => {
  //   document.querySelectorAll('.amo-button-holder').forEach((buttonHolder) => {
  //     buttonHolder.style.setProperty('display', 'none', 'important');
  //   });
  // };

  // const watchAmoButtonHolders = () => {
  //   hideAmoButtonHolders();
  // };

  // if (document.readyState === 'loading') {
  //   document.addEventListener('DOMContentLoaded', watchAmoButtonHolders);
  // }

  const normalizeDiscountCode = (value) => value.trim().toLowerCase();

  const collectDiscountTitles = (cart) => {
    const titles = [];

    (cart.cart_level_discount_applications || []).forEach((discount) => {
      if (discount.title) {
        titles.push(discount.title);
      }
    });

    (cart.items || []).forEach((item) => {
      (item.discounts || []).forEach((discount) => {
        if (discount.title) {
          titles.push(discount.title);
        }
      });

      (item.line_level_discount_allocations || []).forEach((allocation) => {
        if (allocation.discount_application && allocation.discount_application.title) {
          titles.push(allocation.discount_application.title);
        }
      });
    });

    return titles.map(normalizeDiscountCode);
  };

  document.querySelectorAll('[data-cart-discount-form]').forEach((discountForm) => {
    if (discountForm.dataset.discountReady === 'true') {
      return;
    }

    discountForm.dataset.discountReady = 'true';

    const input = discountForm.querySelector('[data-cart-discount-input]');
    const button = discountForm.querySelector('[data-cart-discount-apply]');
    const message = discountForm.querySelector('[data-cart-discount-message]');
    const cartUpdateUrl = discountForm.dataset.cartUpdateUrl;
    const cartUrl = discountForm.dataset.cartUrl;

    if (!input || !button || !message || !cartUpdateUrl || !cartUrl) {
      return;
    }

    const setMessage = (text, state) => {
      message.textContent = text;
      message.classList.toggle('is-success', state === 'success');
      message.classList.toggle('is-error', state === 'error');
    };

    const setLoading = (isLoading) => {
      button.disabled = isLoading;
      input.disabled = isLoading;
      button.textContent = isLoading ? 'Aplicando' : 'Aplicar';
    };

    const applyDiscount = async () => {
      const code = input.value.trim();

      if (!code) {
        setMessage('Digite um cupom para aplicar.', 'error');
        input.focus();
        return;
      }

      setLoading(true);
      setMessage('Aplicando cupom...', '');

      try {
        const beforeResponse = await fetch(`${cartUrl}.js`, {
          headers: {
            Accept: 'application/json',
          },
        });
        const beforeCart = await beforeResponse.json();

        const response = await fetch(cartUpdateUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ discount: code }),
        });

        if (!response.ok) {
          throw new Error('Discount request failed');
        }

        const updatedCart = await response.json();
        const appliedCodes = collectDiscountTitles(updatedCart);
        const normalizedCode = normalizeDiscountCode(code);
        const codeWasApplied = appliedCodes.includes(normalizedCode);
        const discountIncreased = Number(updatedCart.total_discount || 0) > Number(beforeCart.total_discount || 0);
        const totalDecreased = Number(updatedCart.total_price || 0) < Number(beforeCart.total_price || 0);

        if (codeWasApplied || discountIncreased || totalDecreased) {
          setMessage('Cupom aplicado. Atualizando o carrinho...', 'success');
          window.location.assign(cartUrl);
          return;
        }

        setMessage('Cupom inválido ou indisponível para este carrinho.', 'error');
      } catch (error) {
        setMessage('Não foi possível aplicar o cupom agora. Tente novamente.', 'error');
      } finally {
        setLoading(false);
      }
    };

    button.addEventListener('click', applyDiscount);
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        applyDiscount();
      }
    });
  });

  document.querySelectorAll('[data-cart-discount-remove]').forEach((removeButton) => {
    if (removeButton.dataset.discountRemoveReady === 'true') {
      return;
    }

    removeButton.dataset.discountRemoveReady = 'true';

    removeButton.addEventListener('click', async () => {
      const cartUpdateUrl = removeButton.dataset.cartUpdateUrl;
      const cartUrl = removeButton.dataset.cartUrl;

      if (!cartUpdateUrl || !cartUrl) {
        return;
      }

      removeButton.disabled = true;
      removeButton.textContent = 'Removendo';

      try {
        const response = await fetch(cartUpdateUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ discount: '' }),
        });

        if (!response.ok) {
          throw new Error('Discount removal failed');
        }

        window.location.assign(cartUrl);
      } catch (error) {
        removeButton.disabled = false;
        removeButton.textContent = 'Remover';
      }
    });
  });

  document.querySelectorAll('[data-cart-checkout-button]').forEach((checkoutButton) => {
    if (checkoutButton.dataset.checkoutDiscountReady === 'true') {
      return;
    }

    checkoutButton.dataset.checkoutDiscountReady = 'true';

    checkoutButton.addEventListener('click', (event) => {
      if (window.yampiActive) {
        return;
      }

      const form = checkoutButton.form;
      const discountInput = form ? form.querySelector('[data-cart-discount-input]') : null;
      const typedDiscountCode = discountInput ? discountInput.value.trim() : '';
      const appliedDiscountCode = checkoutButton.dataset.appliedDiscountCode || '';
      const discountCode = typedDiscountCode || appliedDiscountCode.trim();

      if (!discountCode) {
        return;
      }

      event.preventDefault();

      const rootUrl = checkoutButton.dataset.rootUrl || '/';
      const normalizedRootUrl = rootUrl.endsWith('/') ? rootUrl.slice(0, -1) : rootUrl;
      const discountUrl = `${normalizedRootUrl}/discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent('/checkout')}`;

      checkoutButton.disabled = true;
      checkoutButton.textContent = 'Finalizando';
      window.location.assign(discountUrl);
    });
  });

  /*
  Shipping estimator kept for future use. Frete is currently always free.

  const formatShippingPrice = (price, currency) => {
    const numericPrice = Number.parseFloat(String(price).replace(',', '.'));

    if (!Number.isFinite(numericPrice)) {
      return String(price);
    }

    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency,
    }).format(numericPrice);
  };

  const buildShippingRatesUrl = (cartUrl, endpoint, zip, country) => {
    const params = new URLSearchParams();
    params.set('shipping_address[zip]', zip);
    params.set('shipping_address[country]', country);

    return `${cartUrl}/${endpoint}.json?${params.toString()}`;
  };

  document.querySelectorAll('[data-cart-shipping-estimator]').forEach((shippingEstimator) => {
    if (shippingEstimator.dataset.shippingReady === 'true') {
      return;
    }

    shippingEstimator.dataset.shippingReady = 'true';

    const input = shippingEstimator.querySelector('[data-cart-shipping-zip]');
    const button = shippingEstimator.querySelector('[data-cart-shipping-calculate]');
    const message = shippingEstimator.querySelector('[data-cart-shipping-message]');
    const ratesContainer = shippingEstimator.querySelector('[data-cart-shipping-rates]');
    const cartUrl = shippingEstimator.dataset.cartUrl;
    const country = shippingEstimator.dataset.country || 'Brazil';
    const currency = shippingEstimator.dataset.currency || 'BRL';

    if (!input || !button || !message || !ratesContainer || !cartUrl) {
      return;
    }

    const setShippingMessage = (text, state) => {
      message.textContent = text;
      message.classList.toggle('is-success', state === 'success');
      message.classList.toggle('is-error', state === 'error');
    };

    const setShippingLoading = (isLoading) => {
      button.disabled = isLoading;
      input.disabled = isLoading;
      button.textContent = isLoading ? 'Calculando' : 'Calcular';
    };

    const renderShippingRates = (rates) => {
      ratesContainer.textContent = '';

      rates.forEach((rate) => {
        const rateRow = document.createElement('div');
        const rateName = document.createElement('span');
        const ratePrice = document.createElement('strong');

        rateRow.className = 'cart-summary__shipping-rate';
        rateName.textContent = rate.name || rate.code || 'Frete';
        ratePrice.textContent = formatShippingPrice(rate.price, currency);

        rateRow.append(rateName, ratePrice);
        ratesContainer.append(rateRow);
      });
    };

    const fetchShippingRates = async (zip) => {
      const prepareUrl = buildShippingRatesUrl(cartUrl, 'prepare_shipping_rates', zip, country);
      const ratesUrl = buildShippingRatesUrl(cartUrl, 'async_shipping_rates', zip, country);

      await fetch(prepareUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
      });

      for (let attempt = 0; attempt < 8; attempt += 1) {
        const response = await fetch(ratesUrl, {
          headers: {
            Accept: 'application/json',
          },
        });

        if (response.ok) {
          const data = await response.json();

          if (Array.isArray(data.shipping_rates)) {
            return data.shipping_rates;
          }
        }

        await new Promise((resolve) => {
          window.setTimeout(resolve, 700);
        });
      }

      return [];
    };

    const calculateShipping = async () => {
      const zip = input.value.replace(/\D/g, '');

      if (zip.length < 8) {
        ratesContainer.textContent = '';
        setShippingMessage('Digite um CEP válido para calcular.', 'error');
        input.focus();
        return;
      }

      setShippingLoading(true);
      setShippingMessage('Calculando opções de frete...', '');
      ratesContainer.textContent = '';

      try {
        const rates = await fetchShippingRates(zip);

        if (rates.length === 0) {
          setShippingMessage('Não encontramos opções de frete para este CEP.', 'error');
          return;
        }

        renderShippingRates(rates);
        setShippingMessage('Fretes estimados:', 'success');
      } catch (error) {
        setShippingMessage('Não foi possível calcular o frete agora. Tente novamente.', 'error');
      } finally {
        setShippingLoading(false);
      }
    };

    input.addEventListener('input', () => {
      const digits = input.value.replace(/\D/g, '').slice(0, 8);
      const formattedZip = digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
      input.value = formattedZip;
    });

    button.addEventListener('click', calculateShipping);
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        calculateShipping();
      }
    });
  });
  */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exit-intent-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storage = {
      get(type, key) {
        try {
          return window[type].getItem(key);
        } catch {
          return null;
        }},
      set(type, key, value) {
        try {
          window[type].setItem(key, value);
        } catch {
          return;
        }}
    };

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-exit-intent]').forEach((component) => {
  if (component.dataset.ready === 'true') return;
        


        component.dataset.ready = 'true';

        const dialog = component.querySelector('[data-exit-intent-dialog]');
        const closeButton = component.querySelector('[data-exit-intent-close]');
        const acceptButton = component.querySelector('[data-exit-intent-accept]');
        const copyButton = component.querySelector('[data-exit-intent-copy]');
        const copyStatus = component.querySelector('[data-exit-intent-copy-status]');

        if (! dialog || ! closeButton || ! acceptButton || ! copyButton || ! copyStatus) return;
        


        const controller = new AbortController();
        const {signal} = controller;
        const sectionId = component.dataset.sectionId;
        const sessionKey = `solvita:exit-intent:shown:${sectionId}`;
        const dismissedKey = `solvita:exit-intent:dismissed:${sectionId}`;
        const convertedKey = `solvita:exit-intent:converted:${sectionId}`;
        const desktopDelay = Number(component.dataset.desktopDelay);
        const mobileDelay = Number(component.dataset.mobileDelay);
        const mobileScrollDepth = Number(component.dataset.mobileScrollDepth) / 100;
        const dismissDuration = Number(component.dataset.dismissMinutes) * 60000;
        const convertedDuration = Number(component.dataset.convertedMinutes) * 60000;
        const desktopEnabled = component.dataset.desktopEnabled === 'true';
        const mobileEnabled = component.dataset.mobileEnabled === 'true';
        const mobileBackEnabled = component.dataset.mobileBackEnabled === 'true';
        const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        const historyStateKey = `solvitaExitIntent:${sectionId}`;
        const startedAt = performance.now();
        const pointerSamples = [];
        const scrollSamples = [];
        let hasInteracted = false;
        let maxScrollY = window.scrollY;
        let triggerSource = '';
        let copiedTimeout;
        let backIntentTimer;
        let isApplyingDiscount = false;
        let backIntentArmed = Boolean(history.state && history.state[historyStateKey]);
        let backIntentConsumed = false;

        const isSuppressed =() => {
          if (storage.get('sessionStorage', sessionKey) === 'true')
            return true;
          


          const dismissedUntil = Number(storage.get('localStorage', dismissedKey) || 0);
          const convertedUntil = Number(storage.get('localStorage', convertedKey) || 0);

          return dismissedUntil > Date.now() || convertedUntil > Date.now();
        };

        const hasBlockingInterface =() => {
          const activeElement = document.activeElement;
          const formFieldActive = activeElement instanceof HTMLInputElement || activeElement instanceof HTMLTextAreaElement || activeElement instanceof HTMLSelectElement || activeElement ?. isContentEditable;

          if (formFieldActive)
            return true;
          


          return Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]')).some((element) => {
            return element !== dialog && element.getClientRects().length > 0;
          });
        };

        const canOpen =( delay) => {
          return(hasInteracted && performance.now() - startedAt >= delay && document.visibilityState === 'visible' && ! dialog.open && ! isSuppressed() && ! hasBlockingInterface());
        };

        const withTransition =( action) => {
          if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            document.startViewTransition(action);
            return;
          }

          action();
        };

        const openDialog =( source, delay) => {
          if (! canOpen(delay)) return;
          


          triggerSource = source;
          storage.set('sessionStorage', sessionKey, 'true');

          withTransition(() => {
            dialog.showModal();
          });
        };

        const armMobileBackIntent =() => {
          if (! mobileEnabled || ! mobileBackEnabled || isDesktop || backIntentArmed || backIntentConsumed || isSuppressed()) return;
          


          if (document.visibilityState !== 'visible') return;
          


          const currentState = history.state && typeof history.state === 'object'
            ? history.state
            : {};

          try {
            history.pushState({
              ... currentState,
              [historyStateKey]: true
            }, '', window.location.href);
            backIntentArmed = true;
          } catch {
            return;
          }};

        const scheduleMobileBackIntent = () => {
          if (! mobileEnabled || ! mobileBackEnabled || isDesktop || backIntentArmed || backIntentConsumed || backIntentTimer || isSuppressed()) return;
          


          const remainingDelay = Math.max(mobileDelay - (performance.now() - startedAt), 0);

          if (remainingDelay === 0) {
            armMobileBackIntent();
            return;
          }

          backIntentTimer = window.setTimeout(() => {
            backIntentTimer = undefined;
            armMobileBackIntent();
          }, remainingDelay);
        };

        const onPopState = () => {
          if (! backIntentArmed || backIntentConsumed) return;
          


          backIntentArmed = false;
          backIntentConsumed = true;

          if (canOpen(mobileDelay)) {
            openDialog('mobile-back', mobileDelay);
            return;
          }

          window.setTimeout(() => {
            history.back();
          }, 0);
        };

        const dismissDialog = () => {
          withTransition(() => {
            dialog.close('dismissed');
          });
        };

        const markInteraction = () => {
          hasInteracted = true;
          scheduleMobileBackIntent();
        };

        const onPointerMove = (event) => {
          markInteraction();
          pointerSamples.push({y: event.clientY, time: performance.now()});

          while (pointerSamples.length > 4) 
            pointerSamples.shift();
          


        };

        const onMouseOut = (event) => {
        if (! desktopEnabled || ! isDesktop) return;
            


            if (event.relatedTarget || event.clientY > 10 || pointerSamples.length < 2) return;
            


            const first = pointerSamples[0];
            const last = pointerSamples[pointerSamples.length - 1];
            const elapsed = Math.max(last.time - first.time, 1);
            const velocity = (last.y - first.y) / elapsed;

            if (last.y<= 20 && velocity <= -0.12) {
            openDialog('desktop', desktopDelay);
          }
        };

        const onScroll = () => {
          markInteraction();
          maxScrollY = Math.max(maxScrollY, window.scrollY);

          if (!mobileEnabled || isDesktop) return;

          const now = performance.now();
          scrollSamples.push({ y: window.scrollY, time: now });

          while (scrollSamples.length && now - scrollSamples[0].time> 800) {
              scrollSamples.shift();
            }

            const scrollableDistance = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
            const reachedRequiredDepth = maxScrollY >= scrollableDistance * mobileScrollDepth;
            const nearTop = window.scrollY<= document.documentElement.scrollHeight * 0.2;

          if (!reachedRequiredDepth || !nearTop || scrollSamples.length < 2) return;

          const upwardDistance = scrollSamples[0].y - window.scrollY;

          if (upwardDistance >= window.innerHeight * 0.3) {
            openDialog('mobile', mobileDelay);
            scrollSamples.length = 0;
          }
        };

        const fallbackCopy = (text) => {
              const textarea = document.createElement('textarea');
              textarea.value = text;
              textarea.setAttribute('readonly', '');
              textarea.style.position = 'fixed';
              textarea.style.opacity = '0';
              document.body.append(textarea);
              textarea.select();

              try {
                return document.execCommand('copy');
              } catch 
              {
                return false;
              } finally {
                textarea.remove();
              }
            


          };

          const copyCode = async () => {
            const code = copyButton.querySelector('strong') ?. textContent ?. trim();

            if (! code) return;
            


            let copied = false;

            if (window.isSecureContext && navigator.clipboard ?. writeText) {
              try {
                await navigator.clipboard.writeText(code);
                copied = true;
              } catch {
                copied = fallbackCopy(code);
              }} else {
              copied = fallbackCopy(code);
            }

            if (! copied) return;
            


            window.clearTimeout(copiedTimeout);
            copyButton.classList.add('is-copied');
            copyStatus.textContent = copyButton.dataset.copiedLabel;
            copiedTimeout = window.setTimeout(() => {
              copyButton.classList.remove('is-copied');
              copyStatus.textContent = '';
            }, 1800);
          };

          closeButton.addEventListener('click', dismissDialog, {signal});
          copyButton.addEventListener('click', copyCode, {signal});

          acceptButton.addEventListener('click', async (event) => {
            event.preventDefault();

            if (isApplyingDiscount) return;
            


            isApplyingDiscount = true;
            acceptButton.setAttribute('aria-disabled', 'true');

            try {
              const response = await fetch(acceptButton.dataset.cartUpdateUrl, {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
                },
                credentials: 'same-origin',
                body: JSON.stringify(
                  {discount: acceptButton.dataset.discountCode}
                ),
                signal
              });

              if (! response.ok) 
                throw new Error('Unable to apply discount');
              


              storage.set('localStorage', convertedKey, String(Date.now() + convertedDuration));
              dialog.close('converted');
              window.location.assign(acceptButton.dataset.cartUrlWithDiscount);
            } catch (error) {
              if (error.name === 'AbortError') return;
              


              window.location.assign(acceptButton.href);
            } finally {
              isApplyingDiscount = false;
              acceptButton.removeAttribute('aria-disabled');
            }
          }, {signal});

          dialog.addEventListener('click', (event) => {
            if (event.target === dialog) 
              dismissDialog();
            


          }, {signal});

          dialog.addEventListener('close', () => {
            if (dialog.returnValue !== 'converted') {
              storage.set('localStorage', dismissedKey, String(Date.now() + dismissDuration));
            }

            dialog.dataset.trigger = triggerSource;
          }, {signal});

          signal.addEventListener('abort', () => {
            window.clearTimeout(copiedTimeout);
            window.clearTimeout(backIntentTimer);
          }, {once: true});

          window.addEventListener('popstate', onPopState, {signal});
          document.addEventListener('pointermove', onPointerMove, {signal, passive: true});
          document.addEventListener('mouseout', onMouseOut, {signal, passive: true});
          document.addEventListener('scroll', onScroll, {signal, passive: true});
          document.addEventListener('click', markInteraction, {signal, passive: true});
          document.addEventListener('keydown', markInteraction, {signal, passive: true});
          document.addEventListener('touchstart', markInteraction, {signal, passive: true});

          component.exitIntentCleanup = () => controller.abort();
        }
      );
    };

    initialize();

    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-exit-intent]').forEach((component) => {
        component.exitIntentCleanup ?. ();
      });
    });
  }
)();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const drawer = document.querySelector('[data-header-mobile-menu]');
    const openButton = document.querySelector('[data-mobile-menu-open]');

    if (!drawer || !openButton) {
      return;
    }

    if (drawer.dataset.initialized === 'true') {
      return;
    }

    drawer.dataset.initialized = 'true';

    const closeButtons = drawer.querySelectorAll('[data-mobile-menu-close]');
    const detailNodes = drawer.querySelectorAll('details');
    let lastFocusedElement = null;

    const setDrawerState = (isOpen) => {
      if (isOpen) {
        lastFocusedElement = document.activeElement;
        drawer.hidden = false;
        window.requestAnimationFrame(() => {
          drawer.classList.add('is-open');
        });
        document.body.classList.add('header-mobile-menu-open');
        openButton.setAttribute('aria-expanded', 'true');
        return;
      }

      drawer.classList.remove('is-open');
      document.body.classList.remove('header-mobile-menu-open');
      openButton.setAttribute('aria-expanded', 'false');
      detailNodes.forEach((node) => {
        node.open = false;
      });

      if (lastFocusedElement instanceof HTMLElement) {
        lastFocusedElement.focus();
      } else {
        openButton.focus();
      }
    };

    drawer.addEventListener('transitionend', (event) => {
      if (event.target !== drawer) {
        return;
      }

      if (!drawer.classList.contains('is-open')) {
        drawer.hidden = true;
      }
    });

    openButton.addEventListener('click', () => {
      setDrawerState(true);
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setDrawerState(false);
      });
    });

    drawer.addEventListener('click', (event) => {
      const targetLink = event.target.closest('a');

      if (!targetLink) {
        return;
      }

      setDrawerState(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !drawer.hidden) {
        setDrawerState(false);
      }
    });

    const desktopMedia = window.matchMedia('(min-width: 750px)');
    const handleDesktopState = (event) => {
      if (event.matches && !drawer.hidden) {
        setDrawerState(false);
      }
    };

    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', handleDesktopState);
    } else {
      desktopMedia.addListener(handleDesktopState);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner-index"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const banners = document.querySelectorAll('[data-hero-banner]');

    banners.forEach((root) => {
      if (root.dataset.heroBannerReady === 'true') return;

      root.dataset.heroBannerReady = 'true';

      const carousel = root.querySelector('[data-hero-carousel]');
      const track = root.querySelector('[data-hero-track]');
      const slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
      const previousButton = root.querySelector('[data-hero-previous]');
      const nextButton = root.querySelector('[data-hero-next]');

      if (!carousel || !track || slides.length <= 1) return;

      const autoplayEnabled = carousel.dataset.autoplay === 'true';
      const autoplayInterval = Number(carousel.dataset.interval || 5000);
      let activeIndex = 0;
      let autoplayTimer = null;
      let remainingTime = autoplayInterval;
      let autoplayStartedAt = 0;
      let progressFrame = null;
      let swipeStartX = 0;
      let swipeStartY = 0;
      let swipePointerId = null;
      let suppressClick = false;

      const setProgress = (ratio) => {
        dots.forEach((dot, dotIndex) => {
          dot.style.setProperty('--hero-dot-progress', dotIndex === activeIndex ? `${ratio}` : '0');
        });
      };

      const stopProgressLoop = () => {
        if (progressFrame) {
          window.cancelAnimationFrame(progressFrame);
          progressFrame = null;
        }
      };

      const startProgressLoop = () => {
        stopProgressLoop();

        if (!autoplayEnabled || !autoplayStartedAt) return;

        const initialElapsed = autoplayInterval - remainingTime;

        const tick = () => {
          if (!autoplayStartedAt) return;

          const elapsed = initialElapsed + (window.performance.now() - autoplayStartedAt);
          const ratio = Math.max(0, Math.min(1, elapsed / autoplayInterval));

          setProgress(ratio);

          if (ratio < 1 && autoplayTimer) {
            progressFrame = window.requestAnimationFrame(tick);
          }
        };

        progressFrame = window.requestAnimationFrame(tick);
      };

      const updateSlides = (index) => {
        activeIndex = index;
        remainingTime = autoplayInterval;
        stopProgressLoop();

        slides.forEach((slide, slideIndex) => {
          slide.classList.toggle('is-active', slideIndex === index);
        });

        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        setProgress(0);
      };

      const goToSlide = (index) => {
        const normalizedIndex = (index + slides.length) % slides.length;
        updateSlides(normalizedIndex);
        restartAutoplay();
      };

      const startAutoplay = () => {
        if (!autoplayEnabled || autoplayTimer) return;

        if (remainingTime <= 0) {
          remainingTime = autoplayInterval;
        }

        carousel.classList.remove('is-paused');
        autoplayStartedAt = window.performance.now();
        startProgressLoop();

        autoplayTimer = window.setTimeout(() => {
          stopProgressLoop();
          autoplayTimer = null;
          autoplayStartedAt = 0;
          updateSlides((activeIndex + 1) % slides.length);
          startAutoplay();
        }, remainingTime);
      };

      const stopAutoplay = () => {
        if (autoplayTimer) {
          const elapsed = window.performance.now() - autoplayStartedAt;
          remainingTime = Math.max(0, remainingTime - elapsed);
          window.clearTimeout(autoplayTimer);
          autoplayTimer = null;
          autoplayStartedAt = 0;
        }

        stopProgressLoop();
        carousel.classList.add('is-paused');
      };

      const restartAutoplay = () => {
        stopAutoplay();
        remainingTime = autoplayInterval;
        startAutoplay();
      };

      if (previousButton) {
        previousButton.addEventListener('click', () => goToSlide(activeIndex - 1));
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => goToSlide(activeIndex + 1));
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          goToSlide(Number(dot.dataset.index || 0));
        });
      });

      carousel.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;

        swipeStartX = event.clientX;
        swipeStartY = event.clientY;
        swipePointerId = event.pointerId;
        suppressClick = false;
        stopAutoplay();
      });

      carousel.addEventListener('pointerup', (event) => {
        if (swipePointerId !== event.pointerId) return;

        const deltaX = event.clientX - swipeStartX;
        const deltaY = event.clientY - swipeStartY;
        const isHorizontalSwipe = Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2;

        swipePointerId = null;

        if (isHorizontalSwipe) {
          suppressClick = true;
          goToSlide(deltaX < 0 ? activeIndex + 1 : activeIndex - 1);
          return;
        }

        startAutoplay();
      });

      carousel.addEventListener('pointercancel', () => {
        swipePointerId = null;
        startAutoplay();
      });

      carousel.addEventListener('click', (event) => {
        if (!suppressClick) return;

        event.preventDefault();
        suppressClick = false;
      }, true);

      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', (event) => {
        if (!carousel.contains(event.relatedTarget)) {
          startAutoplay();
        }
      });

      updateSlides(0);
      startAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (() => {
    const form = document.getElementById('PasswordNewsletterForm');

    if (!form) return;

    const tagsField = form.querySelector('#PasswordNewsletterTags');
    const giftInputs = form.querySelectorAll('input[name="contact[gift_choice]"]');
    const baseTags = 'newsletter, password page';

    const syncTags = () => {
      if (!tagsField) return;

      const selectedGift = form.querySelector('input[name="contact[gift_choice]"]:checked');

      if (!selectedGift) {
        tagsField.value = baseTags;
        return;
      }

      const giftTag = selectedGift.dataset.giftTag;

      if (!giftTag) {
        tagsField.value = baseTags;
        return;
      }

      tagsField.value = `${baseTags}, ${giftTag}`;
    };

    giftInputs.forEach((input) => {
      input.addEventListener('change', syncTags);
    });

    syncTags();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  const updateProductCarouselControls = (track) => {
    const viewport = track.closest('.product-carousel__viewport');
    const controls = viewport && viewport.querySelectorAll('.product-carousel__control');

    if (! controls) {
      return;
    }

    const hasOverflow = track.scrollWidth > track.clientWidth + 1;

    controls.forEach((control) => {
      control.hidden = ! hasOverflow;
    });
  };

  document.querySelectorAll('[data-product-carousel-track]').forEach(updateProductCarouselControls);

  window.addEventListener('resize', () => {
    document.querySelectorAll('[data-product-carousel-track]').forEach(updateProductCarouselControls);
  });

  document.addEventListener('click', (event) => {
    const control = event.target.closest('.product-carousel__control');

    if (! control) {
      return;
    }

    const viewport = control.closest('.product-carousel__viewport');
    const track = viewport && viewport.querySelector('[data-product-carousel-track]');

    if (! track) {
      return;
    }

    const direction = control.classList.contains('product-carousel__control--next')
      ? 1
      : -1;
    const slide = track.querySelector('.product-carousel__slide');
    const distance = slide
      ? slide.getBoundingClientRect().width + 16
      : track.clientWidth;

    track.scrollBy({
      left: distance * direction,
      behavior: 'smooth'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-combo"]) return;
  try {
    
  document.querySelectorAll('[data-product-combo]').forEach((sectionRoot) => {
    if (sectionRoot.dataset.productComboReady === 'true') {
      return;
    }

    sectionRoot.dataset.productComboReady = 'true';

    const form = sectionRoot.querySelector('.product-combo__form');
    const variantSelect = sectionRoot.querySelector('[data-product-combo-variant-select]');
    const price = sectionRoot.querySelector('[data-product-combo-price]');
    const comparePrice = sectionRoot.querySelector('[data-product-combo-compare-price]');
    const installments = sectionRoot.querySelector('[data-product-combo-installments]');
    const submitButton = sectionRoot.querySelector('[data-product-combo-submit]');
    const floatingWrap = document.querySelector('[data-product-combo-floating-wrap]');
    const floatingVariantInput = floatingWrap
      ? floatingWrap.querySelector('[data-product-combo-floating-variant-input]')
      : null;
    const floatingImage = floatingWrap
      ? floatingWrap.querySelector('[data-product-combo-floating-image]')
      : null;
    const floatingPrice = floatingWrap
      ? floatingWrap.querySelector('[data-product-combo-floating-price]')
      : null;
    const floatingVariant = floatingWrap
      ? floatingWrap.querySelector('[data-product-combo-floating-variant]')
      : null;
    const floatingSubmit = floatingWrap
      ? floatingWrap.querySelector('[data-product-combo-floating-submit]')
      : null;
    const purchaseRoot = sectionRoot.querySelector('[data-product-combo-purchase-root]');
    const mainImage = sectionRoot.querySelector('.product-combo__main-image');
    const mediaStage = sectionRoot.querySelector('.product-combo__media-stage');
    const thumbButtons = sectionRoot.querySelectorAll('[data-product-combo-thumb]');
    const prevGalleryButton = sectionRoot.querySelector('[data-product-combo-gallery-prev]');
    const nextGalleryButton = sectionRoot.querySelector('[data-product-combo-gallery-next]');
    const variantTriggers = sectionRoot.querySelectorAll('[data-product-combo-variant-trigger]');
    const thumbButtonList = Array.from(thumbButtons);
    let currentImageIndex = Math.max(0, thumbButtonList.findIndex((button) => button.classList.contains('is-current')));

    const syncThumbState = (imageId) => {
      thumbButtons.forEach((button) => {
        const isCurrent = button.dataset.imageId === imageId;
        button.classList.toggle('is-current', isCurrent);
        button.setAttribute(
          'aria-pressed',
          isCurrent
            ? 'true'
            : 'false'
        );
      });
    };

    const showImageByIndex = (index) => {
      if (! thumbButtonList.length) {
        return;
      }

      const normalizedIndex = (index + thumbButtonList.length) % thumbButtonList.length;
      const button = thumbButtonList[normalizedIndex];

      if (! button) {
        return;
      }

      currentImageIndex = normalizedIndex;

      if (mainImage) {
        mainImage.setAttribute('src', button.dataset.imageSrc || '');
        mainImage.setAttribute('srcset', button.dataset.imageSrc || '');
        mainImage.setAttribute('alt', button.dataset.imageAlt || '');
      }

      if (floatingImage) {
        floatingImage.setAttribute('src', button.dataset.imageSrc || '');
        floatingImage.setAttribute('srcset', button.dataset.imageSrc || '');
        floatingImage.setAttribute('alt', button.dataset.imageAlt || '');
      }

      if (mediaStage) {
        mediaStage.style.setProperty('--product-combo-image-scale', '1');
        mediaStage.style.setProperty('--product-combo-image-x', '50%');
        mediaStage.style.setProperty('--product-combo-image-y', '50%');
      }

      syncThumbState(button.dataset.imageId);
      button.scrollIntoView({behavior: 'smooth', inline: 'center', block: 'nearest'});
    };

    thumbButtons.forEach((button) => {
      button.addEventListener('click', () => {
        currentImageIndex = thumbButtonList.findIndex((item) => item.dataset.imageId === button.dataset.imageId);
        showImageByIndex(currentImageIndex);
      });
    });

    if (prevGalleryButton) {
      prevGalleryButton.addEventListener('click', () => {
        showImageByIndex(currentImageIndex - 1);
      });
    }

    if (nextGalleryButton) {
      nextGalleryButton.addEventListener('click', () => {
        showImageByIndex(currentImageIndex + 1);
      });
    }

    if (mediaStage && mainImage) {
      mediaStage.addEventListener('mousemove', (event) => {
        const bounds = mediaStage.getBoundingClientRect();
        const x = ((event.clientX - bounds.left) / bounds.width) * 100;
        const y = ((event.clientY - bounds.top) / bounds.height) * 100;

        mediaStage.style.setProperty('--product-combo-image-x', `${x}%`);
        mediaStage.style.setProperty('--product-combo-image-y', `${y}%`);
        mediaStage.style.setProperty('--product-combo-image-scale', '1.85');
      });

      mediaStage.addEventListener('mouseleave', () => {
        mediaStage.style.setProperty('--product-combo-image-scale', '1');
        mediaStage.style.setProperty('--product-combo-image-x', '50%');
        mediaStage.style.setProperty('--product-combo-image-y', '50%');
      });
    }

    const updateVariantState = (option) => {
      if (!option || ! price || ! comparePrice || ! submitButton || ! form || ! purchaseRoot) {
        return;
      }

      const isAvailable = option.dataset.available === 'true';
      const addLabel = purchaseRoot.dataset.addLabel || '';
      const soldOutLabel = purchaseRoot.dataset.soldOutLabel || '';

      price.textContent = option.dataset.price || '';
      comparePrice.textContent = option.dataset.comparePrice || '';
      comparePrice.classList.toggle('is-hidden', !option.dataset.comparePrice);

      if (installments) {
        installments.textContent = option.dataset.installmentPrice || '';
      }

      submitButton.disabled = ! isAvailable;
      submitButton.textContent = isAvailable
        ? addLabel
        : soldOutLabel;

      if (floatingVariantInput) {
        floatingVariantInput.value = option.value || '';
      }

      if (floatingPrice) {
        floatingPrice.textContent = option.dataset.price || '';
      }

      if (floatingVariant) {
        floatingVariant.textContent = option.textContent.trim();
      }

      if (floatingImage && option.dataset.featuredImageSrc) {
        floatingImage.setAttribute('src', option.dataset.featuredImageSrc);
        floatingImage.setAttribute('srcset', option.dataset.featuredImageSrc);
        floatingImage.setAttribute('alt', option.dataset.featuredImageAlt || '');
      }

      if (floatingSubmit) {
        floatingSubmit.disabled = ! isAvailable;
        floatingSubmit.textContent = isAvailable
          ? addLabel
          : soldOutLabel;
      }

      if (option.dataset.featuredImageId) {
        const matchingThumb = sectionRoot.querySelector(`[data-product-combo-thumb][data-image-id="${
          option.dataset.featuredImageId
        }"]`);

        if (matchingThumb) {
          currentImageIndex = thumbButtonList.findIndex((button) => button.dataset.imageId === matchingThumb.dataset.imageId);
          showImageByIndex(currentImageIndex);
        }
      }

      if (variantTriggers.length) {
        variantTriggers.forEach((trigger) => {
          const isCurrent = trigger.dataset.variantId === option.value;
          trigger.classList.toggle('is-current', isCurrent);
          trigger.setAttribute(
            'aria-pressed',
            isCurrent
              ? 'true'
              : 'false'
          );
        });
      }
    };

    if (variantSelect) {
      updateVariantState(variantSelect.selectedOptions[0]);

      variantSelect.addEventListener('change', () => {
        updateVariantState(variantSelect.selectedOptions[0]);
      });

      variantTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          variantSelect.value = trigger.dataset.variantId || '';
          variantSelect.dispatchEvent(new Event('change', {bubbles: true}));
        });
      });
    }

    if (submitButton && floatingWrap && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];

        if (! entry) {
          return;
        }

        const shouldShow = entry.isIntersecting === false && window.scrollY > 0;
        floatingWrap.classList.toggle('is-visible', shouldShow);
      }, {threshold: 0.15});

      observer.observe(submitButton);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-multivitaminico"]) return;
  try {
    
  document.querySelectorAll('[data-omega-product]').forEach((sectionRoot) => {
    if (sectionRoot.dataset.omegaProductReady === 'true') {
      return;
    }

    sectionRoot.dataset.omegaProductReady = 'true';

    const form = sectionRoot.querySelector('.omega-product__form');
    const variantSelect = sectionRoot.querySelector('[data-omega-variant-select]');
    const price = sectionRoot.querySelector('[data-omega-price]');
    const comparePrice = sectionRoot.querySelector('[data-omega-compare-price]');
    const installments = sectionRoot.querySelector('[data-omega-installments]');
    const submitButton = sectionRoot.querySelector('[data-omega-submit]');
    const floatingWrap = document.querySelector('[data-omega-floating-wrap]');
    const floatingVariantInput = floatingWrap
      ? floatingWrap.querySelector('[data-omega-floating-variant-input]')
      : null;
    const floatingImage = floatingWrap
      ? floatingWrap.querySelector('[data-omega-floating-image]')
      : null;
    const floatingPrice = floatingWrap
      ? floatingWrap.querySelector('[data-omega-floating-price]')
      : null;
    const floatingVariant = floatingWrap
      ? floatingWrap.querySelector('[data-omega-floating-variant]')
      : null;
    const floatingSubmit = floatingWrap
      ? floatingWrap.querySelector('[data-omega-floating-submit]')
      : null;
    const purchaseRoot = sectionRoot.querySelector('[data-omega-purchase-root]');
    const mainImage = sectionRoot.querySelector('.omega-product__main-image');
    const mediaStage = sectionRoot.querySelector('.multivita-product__media-stage');
    const thumbButtons = sectionRoot.querySelectorAll('[data-omega-thumb]');
    const prevGalleryButton = sectionRoot.querySelector('[data-omega-gallery-prev]');
    const nextGalleryButton = sectionRoot.querySelector('[data-omega-gallery-next]');
    const variantTriggers = sectionRoot.querySelectorAll('[data-omega-variant-trigger]');
    const thumbButtonList = Array.from(thumbButtons);
    let currentImageIndex = Math.max(0, thumbButtonList.findIndex((button) => button.classList.contains('is-current')));

    const syncThumbState = (imageId) => {
      thumbButtons.forEach((button) => {
        const isCurrent = button.dataset.imageId === imageId;
        button.classList.toggle('is-current', isCurrent);
        button.setAttribute(
          'aria-pressed',
          isCurrent
            ? 'true'
            : 'false'
        );
      });
    };

    const showImageByIndex = (index) => {
      if (! thumbButtonList.length) {
        return;
      }

      const normalizedIndex = (index + thumbButtonList.length) % thumbButtonList.length;
      const button = thumbButtonList[normalizedIndex];

      if (! button) {
        return;
      }

      currentImageIndex = normalizedIndex;

      if (mainImage) {
        mainImage.setAttribute('src', button.dataset.imageSrc || '');
        mainImage.setAttribute('srcset', button.dataset.imageSrc || '');
        mainImage.setAttribute('alt', button.dataset.imageAlt || '');
      }

      if (floatingImage) {
        floatingImage.setAttribute('src', button.dataset.imageSrc || '');
        floatingImage.setAttribute('srcset', button.dataset.imageSrc || '');
        floatingImage.setAttribute('alt', button.dataset.imageAlt || '');
      }

      if (mediaStage) {
        mediaStage.style.setProperty('--omega-image-scale', '1');
        mediaStage.style.setProperty('--omega-image-x', '50%');
        mediaStage.style.setProperty('--omega-image-y', '50%');
      }

      syncThumbState(button.dataset.imageId);
      button.scrollIntoView({behavior: 'smooth', inline: 'center', block: 'nearest'});
    };

    thumbButtons.forEach((button) => {
      button.addEventListener('click', () => {
        currentImageIndex = thumbButtonList.findIndex((item) => item.dataset.imageId === button.dataset.imageId);
        showImageByIndex(currentImageIndex);
      });
    });

    if (prevGalleryButton) {
      prevGalleryButton.addEventListener('click', () => {
        showImageByIndex(currentImageIndex - 1);
      });
    }

    if (nextGalleryButton) {
      nextGalleryButton.addEventListener('click', () => {
        showImageByIndex(currentImageIndex + 1);
      });
    }

    if (mediaStage && mainImage) {
      mediaStage.addEventListener('mousemove', (event) => {
        const bounds = mediaStage.getBoundingClientRect();
        const x = ((event.clientX - bounds.left) / bounds.width) * 100;
        const y = ((event.clientY - bounds.top) / bounds.height) * 100;

        mediaStage.style.setProperty('--omega-image-x', `${x}%`);
        mediaStage.style.setProperty('--omega-image-y', `${y}%`);
        mediaStage.style.setProperty('--omega-image-scale', '1.85');
      });

      mediaStage.addEventListener('mouseleave', () => {
        mediaStage.style.setProperty('--omega-image-scale', '1');
        mediaStage.style.setProperty('--omega-image-x', '50%');
        mediaStage.style.setProperty('--omega-image-y', '50%');
      });
    }

    const updateVariantState = (option) => {
      if (!option || ! price || ! comparePrice || ! submitButton || ! form || ! purchaseRoot) {
        return;
      }

      const isAvailable = option.dataset.available === 'true';
      const addLabel = purchaseRoot.dataset.addLabel || '';
      const soldOutLabel = purchaseRoot.dataset.soldOutLabel || '';

      price.textContent = option.dataset.price || '';
      comparePrice.textContent = option.dataset.comparePrice || '';
      comparePrice.classList.toggle('is-hidden', !option.dataset.comparePrice);

      if (installments) {
        installments.textContent = option.dataset.installmentPrice || '';
      }

      submitButton.disabled = ! isAvailable;
      submitButton.textContent = isAvailable
        ? addLabel
        : soldOutLabel;

      if (floatingVariantInput) {
        floatingVariantInput.value = option.value || '';
      }

      if (floatingPrice) {
        floatingPrice.textContent = option.dataset.price || '';
      }

      if (floatingVariant) {
        floatingVariant.textContent = option.textContent.trim();
      }

      if (floatingImage && option.dataset.featuredImageSrc) {
        floatingImage.setAttribute('src', option.dataset.featuredImageSrc);
        floatingImage.setAttribute('srcset', option.dataset.featuredImageSrc);
        floatingImage.setAttribute('alt', option.dataset.featuredImageAlt || '');
      }

      if (floatingSubmit) {
        floatingSubmit.disabled = ! isAvailable;
        floatingSubmit.textContent = isAvailable
          ? addLabel
          : soldOutLabel;
      }

      if (option.dataset.featuredImageId) {
        const matchingThumb = sectionRoot.querySelector(`[data-omega-thumb][data-image-id="${
          option.dataset.featuredImageId
        }"]`);

        if (matchingThumb) {
          currentImageIndex = thumbButtonList.findIndex((button) => button.dataset.imageId === matchingThumb.dataset.imageId);
          showImageByIndex(currentImageIndex);
        }
      }

      if (variantTriggers.length) {
        variantTriggers.forEach((trigger) => {
          const isCurrent = trigger.dataset.variantId === option.value;
          trigger.classList.toggle('is-current', isCurrent);
          trigger.setAttribute(
            'aria-pressed',
            isCurrent
              ? 'true'
              : 'false'
          );
        });
      }
    };

    if (variantSelect) {
      updateVariantState(variantSelect.selectedOptions[0]);

      variantSelect.addEventListener('change', () => {
        updateVariantState(variantSelect.selectedOptions[0]);
      });

      variantTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          variantSelect.value = trigger.dataset.variantId || '';
          variantSelect.dispatchEvent(new Event('change', {bubbles: true}));
        });
      });
    }

    if (submitButton && floatingWrap && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];

        if (! entry) {
          return;
        }

        const shouldShow = entry.isIntersecting === false && window.scrollY > 0;
        floatingWrap.classList.toggle('is-visible', shouldShow);
      }, {threshold: 0.15});

      observer.observe(submitButton);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-omega"]) return;
  try {
    
  document.querySelectorAll('[data-omega-product]').forEach((sectionRoot) => {
    if (sectionRoot.dataset.omegaProductReady === 'true') {
      return;
    }

    sectionRoot.dataset.omegaProductReady = 'true';

    const form = sectionRoot.querySelector('.omega-product__form');
    const variantSelect = sectionRoot.querySelector('[data-omega-variant-select]');
    const price = sectionRoot.querySelector('[data-omega-price]');
    const comparePrice = sectionRoot.querySelector('[data-omega-compare-price]');
    const installments = sectionRoot.querySelector('[data-omega-installments]');
    const submitButton = sectionRoot.querySelector('[data-omega-submit]');
    const floatingWrap = document.querySelector('[data-omega-floating-wrap]');
    const floatingVariantInput = floatingWrap
      ? floatingWrap.querySelector('[data-omega-floating-variant-input]')
      : null;
    const floatingImage = floatingWrap
      ? floatingWrap.querySelector('[data-omega-floating-image]')
      : null;
    const floatingPrice = floatingWrap
      ? floatingWrap.querySelector('[data-omega-floating-price]')
      : null;
    const floatingVariant = floatingWrap
      ? floatingWrap.querySelector('[data-omega-floating-variant]')
      : null;
    const floatingSubmit = floatingWrap
      ? floatingWrap.querySelector('[data-omega-floating-submit]')
      : null;
    const purchaseRoot = sectionRoot.querySelector('[data-omega-purchase-root]');
    const mainImage = sectionRoot.querySelector('.omega-product__main-image');
    const mediaStage = sectionRoot.querySelector('.omega-product__media-stage');
    const thumbButtons = sectionRoot.querySelectorAll('[data-omega-thumb]');
    const prevGalleryButton = sectionRoot.querySelector('[data-omega-gallery-prev]');
    const nextGalleryButton = sectionRoot.querySelector('[data-omega-gallery-next]');
    const variantTriggers = sectionRoot.querySelectorAll('[data-omega-variant-trigger]');
    const thumbButtonList = Array.from(thumbButtons);
    let currentImageIndex = Math.max(0, thumbButtonList.findIndex((button) => button.classList.contains('is-current')));

    const syncThumbState = (imageId) => {
      thumbButtons.forEach((button) => {
        const isCurrent = button.dataset.imageId === imageId;
        button.classList.toggle('is-current', isCurrent);
        button.setAttribute(
          'aria-pressed',
          isCurrent
            ? 'true'
            : 'false'
        );
      });
    };

    const showImageByIndex = (index) => {
      if (! thumbButtonList.length) {
        return;
      }

      const normalizedIndex = (index + thumbButtonList.length) % thumbButtonList.length;
      const button = thumbButtonList[normalizedIndex];

      if (! button) {
        return;
      }

      currentImageIndex = normalizedIndex;

      if (mainImage) {
        mainImage.setAttribute('src', button.dataset.imageSrc || '');
        mainImage.setAttribute('srcset', button.dataset.imageSrc || '');
        mainImage.setAttribute('alt', button.dataset.imageAlt || '');
      }

      if (floatingImage) {
        floatingImage.setAttribute('src', button.dataset.imageSrc || '');
        floatingImage.setAttribute('srcset', button.dataset.imageSrc || '');
        floatingImage.setAttribute('alt', button.dataset.imageAlt || '');
      }

      if (mediaStage) {
        mediaStage.style.setProperty('--omega-image-scale', '1');
        mediaStage.style.setProperty('--omega-image-x', '50%');
        mediaStage.style.setProperty('--omega-image-y', '50%');
      }

      syncThumbState(button.dataset.imageId);
      button.scrollIntoView({behavior: 'smooth', inline: 'center', block: 'nearest'});
    };

    thumbButtons.forEach((button) => {
      button.addEventListener('click', () => {
        currentImageIndex = thumbButtonList.findIndex((item) => item.dataset.imageId === button.dataset.imageId);
        showImageByIndex(currentImageIndex);
      });
    });

    if (prevGalleryButton) {
      prevGalleryButton.addEventListener('click', () => {
        showImageByIndex(currentImageIndex - 1);
      });
    }

    if (nextGalleryButton) {
      nextGalleryButton.addEventListener('click', () => {
        showImageByIndex(currentImageIndex + 1);
      });
    }

    if (mediaStage && mainImage) {
      mediaStage.addEventListener('mousemove', (event) => {
        const bounds = mediaStage.getBoundingClientRect();
        const x = ((event.clientX - bounds.left) / bounds.width) * 100;
        const y = ((event.clientY - bounds.top) / bounds.height) * 100;

        mediaStage.style.setProperty('--omega-image-x', `${x}%`);
        mediaStage.style.setProperty('--omega-image-y', `${y}%`);
        mediaStage.style.setProperty('--omega-image-scale', '1.85');
      });

      mediaStage.addEventListener('mouseleave', () => {
        mediaStage.style.setProperty('--omega-image-scale', '1');
        mediaStage.style.setProperty('--omega-image-x', '50%');
        mediaStage.style.setProperty('--omega-image-y', '50%');
      });
    }

    const updateVariantState = (option) => {
      if (!option || ! price || ! comparePrice || ! submitButton || ! form || ! purchaseRoot) {
        return;
      }

      const isAvailable = option.dataset.available === 'true';
      const addLabel = purchaseRoot.dataset.addLabel || '';
      const soldOutLabel = purchaseRoot.dataset.soldOutLabel || '';

      price.textContent = option.dataset.price || '';
      comparePrice.textContent = option.dataset.comparePrice || '';
      comparePrice.classList.toggle('is-hidden', !option.dataset.comparePrice);

      if (installments) {
        installments.textContent = option.dataset.installmentPrice || '';
      }

      submitButton.disabled = ! isAvailable;
      submitButton.textContent = isAvailable
        ? addLabel
        : soldOutLabel;

      if (floatingVariantInput) {
        floatingVariantInput.value = option.value || '';
      }

      if (floatingPrice) {
        floatingPrice.textContent = option.dataset.price || '';
      }

      if (floatingVariant) {
        floatingVariant.textContent = option.textContent.trim();
      }

      if (floatingImage && option.dataset.featuredImageSrc) {
        floatingImage.setAttribute('src', option.dataset.featuredImageSrc);
        floatingImage.setAttribute('srcset', option.dataset.featuredImageSrc);
        floatingImage.setAttribute('alt', option.dataset.featuredImageAlt || '');
      }

      if (floatingSubmit) {
        floatingSubmit.disabled = ! isAvailable;
        floatingSubmit.textContent = isAvailable
          ? addLabel
          : soldOutLabel;
      }

      if (option.dataset.featuredImageId) {
        const matchingThumb = sectionRoot.querySelector(`[data-omega-thumb][data-image-id="${
          option.dataset.featuredImageId
        }"]`);

        if (matchingThumb) {
          currentImageIndex = thumbButtonList.findIndex((button) => button.dataset.imageId === matchingThumb.dataset.imageId);
          showImageByIndex(currentImageIndex);
        }
      }

      if (variantTriggers.length) {
        variantTriggers.forEach((trigger) => {
          const isCurrent = trigger.dataset.variantId === option.value;
          trigger.classList.toggle('is-current', isCurrent);
          trigger.setAttribute(
            'aria-pressed',
            isCurrent
              ? 'true'
              : 'false'
          );
        });
      }
    };

    if (variantSelect) {
      updateVariantState(variantSelect.selectedOptions[0]);

      variantSelect.addEventListener('change', () => {
        updateVariantState(variantSelect.selectedOptions[0]);
      });

      variantTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          variantSelect.value = trigger.dataset.variantId || '';
          variantSelect.dispatchEvent(new Event('change', {bubbles: true}));
        });
      });
    }

    if (submitButton && floatingWrap && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];

        if (! entry) {
          return;
        }

        const shouldShow = entry.isIntersecting === false && window.scrollY > 0;
        floatingWrap.classList.toggle('is-visible', shouldShow);
      }, {threshold: 0.15});

      observer.observe(submitButton);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-product-page]').forEach((sectionRoot) => {
    if (sectionRoot.dataset.productPageReady === 'true') {
      return;
    }

    sectionRoot.dataset.productPageReady = 'true';

    const form = sectionRoot.querySelector('.product-page__form');
    const variantSelect = sectionRoot.querySelector('[data-variant-select]');
    const price = sectionRoot.querySelector('[data-product-price]');
    const comparePrice = sectionRoot.querySelector('[data-product-compare-price]');
    const installments = sectionRoot.querySelector('[data-product-installments]');
    const submitButton = sectionRoot.querySelector('[data-product-submit]');
    const mobileSubmitButton = sectionRoot.querySelector('[data-product-mobile-submit]');
    const mobilePrice = sectionRoot.querySelector('[data-product-mobile-price]');
    const mobileComparePrice = sectionRoot.querySelector('[data-product-mobile-compare-price]');
    const mainImage = sectionRoot.querySelector('.product-page__main-image');
    const mediaStage = sectionRoot.querySelector('.product-page__media-stage');
    const thumbButtons = sectionRoot.querySelectorAll('[data-product-thumb]');
    const prevGalleryButton = sectionRoot.querySelector('[data-product-gallery-prev]');
    const nextGalleryButton = sectionRoot.querySelector('[data-product-gallery-next]');
    const variantTriggers = sectionRoot.querySelectorAll('[data-variant-trigger]');
    const thumbButtonList = Array.from(thumbButtons);
    let currentImageIndex = Math.max(0, thumbButtonList.findIndex((button) => button.classList.contains('is-current')));

    const syncThumbState = (imageId) => {
      thumbButtons.forEach((button) => {
        const isCurrent = button.dataset.imageId === imageId;
        button.classList.toggle('is-current', isCurrent);
        button.setAttribute(
          'aria-pressed',
          isCurrent
            ? 'true'
            : 'false'
        );
      });
    };

    const showImageByIndex = (index) => {
      if (! thumbButtonList.length) {
        return;
      }

      const normalizedIndex = (index + thumbButtonList.length) % thumbButtonList.length;
      const button = thumbButtonList[normalizedIndex];

      if (! button) {
        return;
      }

      currentImageIndex = normalizedIndex;

      if (mainImage) {
        mainImage.src = button.dataset.imageSrc;
        mainImage.alt = button.dataset.imageAlt;
      }

      syncThumbState(button.dataset.imageId);
      button.scrollIntoView({behavior: 'smooth', inline: 'center', block: 'nearest'});
    };

    thumbButtons.forEach((button) => {
      button.addEventListener('click', () => {
        currentImageIndex = thumbButtonList.findIndex((item) => item.dataset.imageId === button.dataset.imageId);
        showImageByIndex(currentImageIndex);
      });
    });

    if (prevGalleryButton) {
      prevGalleryButton.addEventListener('click', () => {
        showImageByIndex(currentImageIndex - 1);
      });
    }

    if (nextGalleryButton) {
      nextGalleryButton.addEventListener('click', () => {
        showImageByIndex(currentImageIndex + 1);
      });
    }

    if (mediaStage && mainImage) {
      mediaStage.classList.add('is-zoomable');

      mediaStage.addEventListener('mousemove', (event) => {
        const bounds = mediaStage.getBoundingClientRect();
        const x = ((event.clientX - bounds.left) / bounds.width) * 100;
        const y = ((event.clientY - bounds.top) / bounds.height) * 100;

        mediaStage.style.setProperty('--product-image-x', `${x}%`);
        mediaStage.style.setProperty('--product-image-y', `${y}%`);
        mediaStage.style.setProperty('--product-image-scale', '1.85');
      });

      mediaStage.addEventListener('mouseleave', () => {
        mediaStage.style.setProperty('--product-image-scale', '1');
        mediaStage.style.setProperty('--product-image-x', '50%');
        mediaStage.style.setProperty('--product-image-y', '50%');
      });
    }

    const updateVariantState = (option) => {
      if (!option || ! price || ! comparePrice || ! submitButton || ! form) {
        return;
      }

      const isAvailable = option.dataset.available === 'true';
      const purchaseRoot = sectionRoot.querySelector('[data-product-purchase-root]');
      const addLabel = purchaseRoot ?. dataset.addLabel || '';
      const soldOutLabel = purchaseRoot ?. dataset.soldOutLabel || '';

      price.textContent = option.dataset.price || '';
      comparePrice.textContent = option.dataset.comparePrice || '';
      comparePrice.classList.toggle('is-hidden', !option.dataset.comparePrice);

      if (installments) {
        installments.textContent = option.dataset.installmentPrice || '';
      }

      submitButton.disabled = ! isAvailable;
      submitButton.textContent = isAvailable
        ? addLabel
        : soldOutLabel;

      if (mobileSubmitButton) {
        mobileSubmitButton.disabled = ! isAvailable;
        mobileSubmitButton.textContent = isAvailable
          ? addLabel
          : soldOutLabel;
      }

      if (mobilePrice) {
        mobilePrice.textContent = option.dataset.price || '';
      }

      if (mobileComparePrice) {
        mobileComparePrice.textContent = option.dataset.comparePrice || '';
        mobileComparePrice.classList.toggle('is-hidden', !option.dataset.comparePrice);
      }

      if (option.dataset.featuredImageId) {
        const matchingThumb = sectionRoot.querySelector(`[data-product-thumb][data-image-id="${
          option.dataset.featuredImageId
        }"]`);

        if (matchingThumb) {
          currentImageIndex = thumbButtonList.findIndex((button) => button.dataset.imageId === matchingThumb.dataset.imageId);
          showImageByIndex(currentImageIndex);
        }
      }

      if (variantTriggers.length) {
        variantTriggers.forEach((trigger) => {
          const isCurrent = trigger.dataset.variantId === option.value;
          trigger.classList.toggle('is-current', isCurrent);
          trigger.setAttribute(
            'aria-pressed',
            isCurrent
              ? 'true'
              : 'false'
          );
        });
      }
    };

    if (variantSelect) {
      updateVariantState(variantSelect.selectedOptions[0]);

      variantSelect.addEventListener('change', () => {
        updateVariantState(variantSelect.selectedOptions[0]);
      });

      variantTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          variantSelect.value = trigger.dataset.variantId || '';
          variantSelect.dispatchEvent(new Event('change', {bubbles: true}));
        });
      });
    }

    if (mobileSubmitButton && form && submitButton) {
      mobileSubmitButton.addEventListener('click', () => {
        if (submitButton.disabled) {
          return;
        }

        form.requestSubmit();
      });
    }

  });

  } catch(e) { console.error(e); }
})();
})();
